import type { Currency, Except } from '@festina-life/core'
import type { ReactElement } from 'react'

import { createRequiredContext } from '../libs'
import type { useThemeContext } from './useThemeContext'

export type ProviderProps = {
  isInDebugMode: boolean
  children:
    | ReactElement
    | ((currentContext: UiContextType) => ReactElement | null | false)
  currency: Currency
}

type UiContextType = Except<ProviderProps, 'children'> &
  ReturnType<typeof useThemeContext>

/** Ui context for a life App. */
const [useUiContext, Provider] =
  createRequiredContext<UiContextType>('UiContext')

export { Provider, useUiContext }
